/* eslint-disable */
import fitvids from 'fitvids';
// waypoints
// import 'waypoints/lib/noframework.waypoints.min.js';
// import 'waypoints/lib/shortcuts/inview.min.js';
import Swiper from 'swiper';
import Cookies from 'js-cookie';
import Chocolat from 'chocolat';
import { CountUp } from 'countup.js';
// import PostFilter from "../classes/postfilter";
import Menu from '../classes/menu';
import Cursor from '../classes/cursor';
import ScrollManager from '../classes/scrollManager';
import VideoPlayerFactory from "../classes/video-player-factory";
import basictable from 'basictable/jquery.basictable';
import Splitting from "splitting";
import ScrollDown from '../classes/scrolldown';
import Slider from "../classes/slider";

export default {
  init() {

    // global namespace
    window.sf = {};
    window.sf.menu = new Menu();
    window.sf.cursor = new Cursor();
    window.sf.scrolldown = new ScrollDown(); // sempre prima di locomotive
    window.sf.sliders = new Slider(); // sempre prima di locomotive

    window.sf.scrollManager = new ScrollManager();


    /*
      serve a mettere le classi small e big
      per ordinare la griglia della galleria immagini
    */
    const wpGalleries = document.querySelectorAll('.blocks-gallery-grid');
    wpGalleries.forEach( (gallery) => {

      const galleryItems = gallery.querySelectorAll('.blocks-gallery-item');
      const assignCounter = {
        'small': 1,
        'big' : 2
      };

      galleryItems.forEach( (item) => {

          if (assignCounter.small < 2) {

            item.classList.add('small');
            assignCounter.small++;

            if (assignCounter.small === 2) {
              assignCounter.big = 0;
            }

          } else if (assignCounter.big < 2) {

            item.classList.add('big');
            assignCounter.big++;

            if (assignCounter.big === 2) {
              assignCounter.small = 0;
            }

          }
        });

    });




    const splittable = document.querySelectorAll('.splitwords');
    splittable.forEach( (el, idx) => {

      const splittedText = Splitting({ target: el, by: 'lines' });

      splittedText[0].words.forEach((function(t, e) {
        var i = document.createElement("span");
        i.innerText = t.innerText,
          i.classList.add("word-inner"),
          t.innerText = "",
          t.appendChild(i)
      }));

    } );


    // ------- cookie banner --------
    /* $('#accept-cookie-button').click(function(){
      Cookies.set('cookie-consent', 'accept', { expires: 365 });
      $('.c-cookieinfo').hide();
    });*/
    // ------- cookie banner --------

    // hover ctapages
    $('.btn-cta').each(function(){

      $(this).hover(function () {
        $(this).closest('.plcol').addClass('onhover');
      },function () {
        $(this).closest('.plcol').removeClass('onhover');
      });

    });

    // blocco tab: fa funzionare le tab
    $('.expnav a').each( function () {
      $(this).click( function(event) {
        event.preventDefault();
        const $tablink = $(this);
        if( ! $tablink.hasClass('active') ) {
          $tablink.parent().find('a').not($tablink).removeClass('active');
          $tablink.addClass('active');
          $( $tablink.attr('href') ).collapse('show');
        }
      });
    });

    // tabelle responsive
    $('.basic-table').basictable({
      breakpoint: 767
    });

    // background non presenti dentro ad un carosello
    const playerFactory = new VideoPlayerFactory();
    document.querySelectorAll('.bkg.has-video').forEach( (el, index) => {
      let player = playerFactory.getPlayer(el, 'html5');
      player.play();
    });

    /*
    * VIDEO MODAL
    */
    if( $('#videoModal').length ) {
      let player = playerFactory.getPlayer(document.querySelector('#videoModal .videoWrapper'), 'html5');

      $('#videoModal').on('shown.bs.modal', function () {
        player.play();
      })
      $('#videoModal').on('hidden.bs.modal', function () {
        player.stop();
      })
    }
    
    if( $('#play-video').length ) {

      const ytVideoWrapper =document.querySelector('.ytvideoWrapper');
      let player = playerFactory.getPlayer(ytVideoWrapper, 'youtube');

      $('#play-video').on('click', function () {
        ytVideoWrapper.classList.add('ytvideoWrapper--active');
        setTimeout(()=>{
          player.play();
        },500);
        
      });

      $('#ytplayerclose').on('click', function () {
        player.stop();
        ytVideoWrapper.classList.remove('ytvideoWrapper--active');
      });

      /*$('#videoModal').on('hidden.bs.modal', function () {
        player.stop();
      })*/
    }


    // da spostare poi su file separato ... è il codice che gestisce il blocco lezioni nella pagine delle formazioni
    document.querySelectorAll('.lezioni__accordion').forEach( (el, index) => {

      $(el).on('hide.bs.collapse', function () {
        let $activeel = $('.lezioni.active');
        $activeel.removeClass('active');
        $activeel.find('button[data-toggle="collapse"]').data('aria-expanded','false');
        $activeel.find('.expcontent').removeClass('show');
      });

      $(el).on('show.bs.collapse', function () {

        $('.lezioni.active').removeClass('active');
        $(event.target).closest('.lezioni').addClass('active');

        let $unactiveLessons = $('.lezioni:not(.active)');
        $unactiveLessons.find('button[data-toggle="collapse"]').data('aria-expanded','false');
        $unactiveLessons.find('.expcontent').removeClass('show');

      });

    });



    document.querySelectorAll('article.team').forEach( (el, index) => {

      // article.team

      // desktop funziona al mousenter altrimenti al click
      if( window.sf.menu.desktopMenuBreakpoint.matches ) {

        el.addEventListener('mouseenter', (e) => {
          //e.target.click();
          e.target.classList.add('team--hover');
        });

        el.addEventListener('mouseleave', (e) => {
          //e.target.click();
          e.target.classList.remove('team--hover');
        });

      } else {

        el.addEventListener('click', (e) => {

          if( e.target.classList.contains('team') ) {

            if( e.target.classList.contains('team--hover')) {
              e.target.classList.remove('team--hover');
            }
            else {
              e.target.classList.add('team--hover');
            }


            document.querySelectorAll('article.team').forEach((innerEl) => {
              if(innerEl !== e.target){
                innerEl.classList.remove('team--hover');
              }
            });

          }


        });

      }



    });


    /* ---- video responsive ----- */
    fitvids();
    /* ---- video responsive ----- */


    // 48em = 768px
    const tabletMinBreakpoint = window.matchMedia('(min-width:48em)');

    // Caroselli Orizzontali (blocco)
    const orizzontalCarousels = document.querySelectorAll('.osl');
    if( orizzontalCarousels.length > 0 ) {
      orizzontalCarousels.forEach( ( carousel ) => {

        const swiperCarousel = new Swiper(carousel, {
          slidesPerView: 'auto',
          loop: true,
          spaceBetween: 0,
          centeredSlides: true,
          // il carosello su questo sito parte dalle seconda slide
          initialSlide: 0, //carousel.querySelectorAll('.ositem').length > 1 ? 1 : 0,
          slideToClickedSlide: false,
          autoplay: {
            delay: 3500,
            disableOnInteraction: true,
          },
          // effect: 'fade',
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          on: {
            init: function () {
              // su mobile attivo chocolat
              /*if( !tabletMinBreakpoint.matches ) {
                Chocolat(carousel.querySelectorAll('.chocolat-image'), {
                  // imageSize: 'cover',
                  allowZoom: true,
                });
              }
              else {*/
                const links = carousel.querySelectorAll('.chocolat-image');

                if( links.length > 0 ) {
                  links.forEach(link => {
                    link.addEventListener("click", function (event) {
                      event.preventDefault();
                    });
                  });
                }

             /* } */

             /* let slideNumber = 0;

              // slides è un oggetto di tipo Dom7 quindi uso il suo ciclo
              // per trovare la slide più alta
              this.slides.each( (idx, slide) => {
                slideNumber++;
              } );

              // forzo il ritorno alla prima slide
              if(slideNumber > 1){
                this.slideTo(0);
              }
*/
            },
          },
        });
      });

    }


    // gallery wordpress con chocolate
    const galleryItems = document.querySelectorAll('.wp-block-gallery .blocks-gallery-item a');
    if( galleryItems.length ) {
      Chocolat(galleryItems, {
        // imageSize: 'cover',
        allowZoom: true,
        // wordpress non inserisce il titolo nel link immagine
        description: function () {
          const currentImage = this.images[this.settings.currentImageIndex];
          const $figcaption = $('a[href="' + currentImage.src +'"]').parent('figure').find('figcaption');
          return $figcaption.length > 0 ? $figcaption.text() : '';
          // return currentImage.title
        }
      });
    }



    // ------- CF7 input file sezione lavora con noi --------
    let cf7Files = document.querySelectorAll('.wpcf7 .custom-file');

    cf7Files.forEach(function(item, index){

      let uploadInput = item.querySelector('input[type="file"]');
      let labelInput = item.querySelector('.custom-file-label');

      if ( uploadInput ) {
        
        uploadInput.onchange = function() {

          let input = this.files[0];
          let text = '';
          
          if (input) {
            text = uploadInput.value.replace("C:\\fakepath\\", "");
          } else {
            text = 'Il tuo CV (file pdf)';
          }

          labelInput.innerHTML = text;
              
        };
      }

    });
    // ------- input file --------

    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js